module.exports = __webpack_public_path__ + "img/no-access.1cde9e41.png";